import axiosInstance from '../config/axiosInstance';

export type PublicUploadResponse = {
  message: string;
  public_token: string;
  file_count: number;
  total_size_bytes: number;
};

export type PublicUploadPayload = {
  companyName: string;
  contactName: string;
  contactEmail: string;
  contactPhone?: string;
  notes?: string;
  files: File[];
};

export const submitPublicUpload = async (
  payload: PublicUploadPayload
): Promise<PublicUploadResponse> => {
  const formData = new FormData();

  formData.append('company_name', payload.companyName);
  formData.append('contact_name', payload.contactName);
  formData.append('contact_email', payload.contactEmail);

  if (payload.contactPhone?.trim()) {
    formData.append('contact_phone', payload.contactPhone.trim());
  }

  if (payload.notes?.trim()) {
    formData.append('notes', payload.notes.trim());
  }

  payload.files.forEach((file) => {
    formData.append('files', file);
  });

  const { data } = await axiosInstance.post<PublicUploadResponse>(
    '/public-uploads/submit',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  return data;
};